import {IFilterService} from "angular";

export const NumberSuffix = "numberSuffix";

export type Magnitude = "k" | "M" | "B" | "T" | "P" | "E";

export type NumberSuffixPipe = (input: number,
                                decimals?: number,
                                magnitude?: Magnitude,
                                unroundedDecimals?: number) => string | null;

/** @ngInject */
export function numberSuffix($filter: IFilterService): NumberSuffixPipe {
    return (input: number, decimals?: number, magnitude: Magnitude = "k", unroundedDecimals?: number) => {
        const suffixes: ReadonlyArray<Magnitude> = ["k", "M", "B", "T", "P", "E"];

        if ((input == null) || (window.isNaN(input))) {
            return null;
        }

        const exp = Math.floor(Math.log(input) / Math.log(1000));
        const minMag = suffixes.indexOf(magnitude);

        if ((exp - 1) < minMag) {
            return $filter("number")(input, unroundedDecimals);
        }

        return (input / Math.pow(1000, exp)).toFixed(decimals) + suffixes[exp - 1];
    };
}
